<div class="layout-container">

  <section class="component-header">
    <h2>Yard</h2>
  </section>

  <div class="search-bar">
    <form #searchForm="ngForm">
      <div class="form-group" *ngIf="selectedSearchOption === 'status'">
        <label class="form-label">Status</label>
        <select class="form-input" [(ngModel)]="pageSearchParams.search" name="statusOption"
          (change)="statusDropDownSearch()">
          <option *ngFor="let status of yardStatus" [value]="status">{{
            status
            }}</option>
        </select>
      </div>
      <div class="form-group" *ngIf="selectedSearchOption !== 'status'">
        <label class="form-label">Search</label>
        <input class="form-input" type="text" name="searchQuery" [(ngModel)]="pageSearchParams.search"
          (input)="statusDropDownSearch()"/>
      </div>
      <div class="form-group" *ngIf="selectedSearchOption">
        <label class="form-label">Parameter</label>
        <select class="form-input" [(ngModel)]="selectedSearchOption" name="searchOption">
          <option *ngFor="let option of searchOptions" [value]="option.value">{{
            option.display
            }}</option>
        </select>
      </div>
    </form>
  </div>

  <ng-container>
    <main class="main-content" (scroll)="onScroll($event)">
      <ul class="yard-list">
        <li *ngFor="let yard of yardList" class="yard-item">
          <location [yard]="yard" [availableTrailers]="lostTrailers" (yardUpdate)="updateYard($event)"
            (updateTrailer)="trailerUpdate($event)"></location>
        </li>
      </ul>
    </main>
  </ng-container>


</div>